<!--
 * @Description: 下载页
 * @Author: liusilin
 * @Date: 2024-12-20 12:28:56
 * @LastEditors: liusilin
 * @LastEditTime: 2024-12-20 15:29:08
-->
<template>
  <div class="download">
    <header>
      <div class="banner-content">
        <el-image class="logo" :src="imgs.logo"></el-image>
        <div class="header--content">
          <h2 class="header--title">简洁易用</h2>
          <p class="header--subtitle"> 任何人都可以随时随地轻松的画画，赶紧下载应用开始你的创作吧！ </p>
          <div class="download-btns">
            <el-button type="success"><!----><!----><span>安卓下载</span></el-button>
            <el-button type="info"><!----><!----><span>IOS下载</span></el-button>
          </div>
        </div>
      </div>
    </header>

    <main>
      <div class="introduct-wrap">
        <div class="introduct--str">
          <el-tag type="warning" effect="dark">轻便功能丰富</el-tag>
          <h4 >多种画笔和图层工具</h4>
          <p >让绘画更贴近手绘的感觉，图层功能让绘画更灵活</p>
        </div>
        <el-image class="detail-img" :src="imgs.detail" />
      </div>
      <footer class="footer"> CopyRight2021 石家庄幻刺网络科技有限公司版权所有 <el-link type="info" :underline="false" href="http://beian.miit.gov.cn/" target="_blank">冀ICP备2021008513号-2</el-link></footer>
    </main>
  </div>
</template>
<script>
export default {
  name: "Download",
  data() {
    return {
      imgs: {
        logo: require("@/assets/img/logo.png"),
        banner: require("@/assets/img/download/banner.jpg"),
        detail: require("@/assets/img/download/detail.jpg")
      }
    };
  },
  created(){

  },
  methods: {
  },
};
</script>

<style lang='scss' scoped>

.download {
  header {
    min-height: 450px;
    height: 37.34375vw;
    background-image: url('../assets/img/download/banner.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 30px 40px;
    position: relative;
    .banner-content {
        max-width: 1000px;
        min-width: 580px;
        margin: 0 auto;
      >.el-image {
          position: relative;
          display: inline-block;
          overflow: hidden;
      }
      .header--content {
          width: 50%;
          display: flex;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-align: start;
          -ms-flex-align: start;
          align-items: flex-start;
          padding-top: 50px;
        .header--title {
            font-size: 52px;
            margin-bottom: 30px;
            margin-top: 0;
        }
        .header--subtitle {
          font-size: 18px;
          margin: 0 0 50px 0;
        }
      }
    }
  }
  main {
    position: relative;
    background-color: #f8f9fa;
    overflow: hidden;
    .introduct-wrap {
      position: relative;
      display: flex;
      justify-content: center;
      .introduct--str {
          position: absolute;
          top: 20px;
          left: 0;
          right: 0;
          max-width: 1000px;
          min-width: 580px;
          margin: 0 auto;
          z-index: 10;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          padding-right: 4vw;
        >h4 {
          font-size: 36px;
          margin-top: 12px;
          margin-bottom: 16px;
        }
        >p {
          font-size: 20px;
          margin: 0;
        }
      }
      .detail-img {
        min-width: 1200px
      }
    }
    .footer {
        background-color: #fff;
        color: #aaa;
        font-size: 12px;
        padding: 40px 0;
        text-align: center;
        position: relative;
        z-index: 5;
        >.el-link {
          color: #909399;
          // font-weight: 500;
          font-size: 12px !important;
        }
    }
  }
}

</style>
